import { RestS } from "../../rest/rest-service";
import { getLocalUser } from "../../components/functions/utilities";

// ip names the discovery scan found the company on but that were never connected
export const fetchSuggestedIps = async (): Promise<Set<string>> => {
  try {
    const companyId = getLocalUser()?.companyId;
    if (!companyId) return new Set<string>();
    const { suggestions } = await RestS.fetchIntegrationSuggestions(companyId);
    // ipName is resolved server-side; integrationPartner is the IP _id
    return new Set<string>(
      (suggestions ?? [])
        .filter((item) => item?.status === "suggested" && item?.ipName)
        .map((item) => item?.ipName)
    );
  } catch (error) {
    console.log("error fetching integration suggestions", error);
    return new Set<string>();
  }
};
